const Stripe = {
	init: function () {
		// This is tempoaray code, remove it when GF has officially added the filter.
		gform.addFilter('gform_stripe_update_payment_amount', function( config ) {
			var currency = _mcg.get_current_currency( formId )
			config.currency = currency.toLowerCase();
			return config;
		} );
		
		gform.addFilter( 'gform_stripe_payment_element_updated_payment_information', function ( paymentInformation, initPaymentInfo, feedId, formId ) {
			var currency = _mcg.get_current_currency(formId);

			/* ensure currency switcher is added to the form, else bail out. */
			if ( !currency ) {
				return paymentInformation; 
			}

			var payment_processing_currency = _mcg.get_form_payment_processing_currency(formId);
			if ( 'forms_base_currency' === payment_processing_currency ) {
				var form_data = window['mcg_form_' + formId];
				paymentInformation.currency = form_data.base_currency.toLowerCase();
				return paymentInformation;
			} else {
				paymentInformation.currency = currency.toLowerCase();
				return paymentInformation;
			}
		} );
	
	},
}

export default Stripe;